<template>
  <div>
    &copy; Chaverim Authors. Published under CC-BY-NC.
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue